import { getManifestSettings } from './documentationWikiHelper';

const parseBool = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return String(value).toLowerCase() === 'true';
};

export const isAssignEndUserDocumentationToAdministratorEnabled = (configurationState) => {
  const fromServer = configurationState?.assignEndUserDocumentationToAdministratorEnabled;
  if (fromServer === undefined || fromServer === null || fromServer === '') {
    return true;
  }
  return parseBool(fromServer, true);
};

export const isDocumentationWikiEndUserEnabled = (configurationState) => {
  const fromServer = configurationState?.documentationWikiEndUserEnabled;
  if (fromServer === undefined || fromServer === null || fromServer === '') {
    return false;
  }
  return parseBool(fromServer, false);
};

export const isDocumentationWikiEnabled = (configurationState) => {
  const fromServer = configurationState?.documentationWikiEnabled;
  if (fromServer !== undefined && fromServer !== null && fromServer !== '') {
    return parseBool(fromServer, false);
  }

  const manifestSettings = getManifestSettings();
  return parseBool(manifestSettings.wikiEnabled, true);
};

export const isDocumentationPdfExportGloballyEnabled = (configurationState) => {
  const fromServer = configurationState?.documentationWikiPdfExportEnabled;
  if (fromServer !== undefined && fromServer !== null && fromServer !== '') {
    return parseBool(fromServer, false);
  }

  const manifestSettings = getManifestSettings();
  return parseBool(manifestSettings.pdfExportEnabled, true);
};

export const isDocumentPdfExportEnabled = (doc, configurationState) => {
  if (!isDocumentationPdfExportGloballyEnabled(configurationState)) {
    return false;
  }

  if (!doc) return false;
  if (doc.pdfExportEnabled === false) return false;
  return true;
};

const normalizePdfExportStrategy = (value, defaultValue = 'backend') => {
  const normalized = String(value || defaultValue).trim().toLowerCase();
  return normalized === 'frontend' ? 'frontend' : 'backend';
};

/** Estrategia PDF: backend (Puppeteer) | frontend (html2pdf.js). Default: backend. */
export const getDocumentationPdfExportStrategy = (configurationState) => {
  const fromServer = configurationState?.documentationWikiPdfExportStrategy;
  if (fromServer !== undefined && fromServer !== null && String(fromServer).trim() !== '') {
    return normalizePdfExportStrategy(fromServer, 'backend');
  }

  const manifestSettings = getManifestSettings();
  return normalizePdfExportStrategy(manifestSettings.pdfExportStrategy, 'backend');
};
